/**
* Copyright (c) 2018 Microsoft Corporation
* Modules Registration
* THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
*/

export const componentDictionary = {};

componentDictionary['__local__|__local__|themes|meriton-mpn|views|components|addtocart'] = {
                c: () => require('partner/themes/meriton-mpn/views/components/addtocart.component.tsx'),
                cn: '__local__-__local__-addtocart'
            };
componentDictionary['__local__|__local__|themes|meriton-mpn|views|components|carticon'] = {
                c: () => require('partner/themes/meriton-mpn/views/components/carticon.component.tsx'),
                cn: '__local__-__local__-carticon'
            };
componentDictionary['__local__|__local__|themes|meriton-mpn|views|components|cartlineitem'] = {
                c: () => require('partner/themes/meriton-mpn/views/components/cartlineitem.component.tsx'),
                cn: '__local__-__local__-cartlineitem'
            };
componentDictionary['__local__|__local__|themes|meriton-mpn|views|components|price'] = {
                c: () => require('partner/themes/meriton-mpn/views/components/price.component.tsx'),
                cn: '__local__-__local__-price'
            };
componentDictionary['__local__|__local__|themes|meriton-mpn|views|components|product-v2'] = {
                c: () => require('partner/themes/meriton-mpn/views/components/product-v2.component.tsx'),
                cn: '__local__-__local__-product-v2'
            };
componentDictionary['__local__|__local__|themes|meriton-mpn|views|components|product'] = {
                c: () => require('partner/themes/meriton-mpn/views/components/product.component.tsx'),
                cn: '__local__-__local__-product'
            };
componentDictionary['__local__|__local__|themes|meriton-mpn|views|components|promocode'] = {
                c: () => require('partner/themes/meriton-mpn/views/components/promocode.component.tsx'),
                cn: '__local__-__local__-promocode'
            };
componentDictionary['__local__|__local__|themes|meriton-mpsw|views|components|addtocart'] = {
                c: () => require('partner/themes/meriton-mpsw/views/components/addtocart.component.tsx'),
                cn: '__local__-__local__-addtocart'
            };
componentDictionary['__local__|__local__|themes|meriton-mpsw|views|components|carticon'] = {
                c: () => require('partner/themes/meriton-mpsw/views/components/carticon.component.tsx'),
                cn: '__local__-__local__-carticon'
            };
componentDictionary['__local__|__local__|themes|meriton-mpsw|views|components|cartlineitem'] = {
                c: () => require('partner/themes/meriton-mpsw/views/components/cartlineitem.component.tsx'),
                cn: '__local__-__local__-cartlineitem'
            };
componentDictionary['__local__|__local__|themes|meriton-mpsw|views|components|price'] = {
                c: () => require('partner/themes/meriton-mpsw/views/components/price.component.tsx'),
                cn: '__local__-__local__-price'
            };
componentDictionary['__local__|__local__|themes|meriton-mpsw|views|components|product-v2'] = {
                c: () => require('partner/themes/meriton-mpsw/views/components/product-v2.component.tsx'),
                cn: '__local__-__local__-product-v2'
            };
componentDictionary['__local__|__local__|themes|meriton-mpsw|views|components|product'] = {
                c: () => require('partner/themes/meriton-mpsw/views/components/product.component.tsx'),
                cn: '__local__-__local__-product'
            };
componentDictionary['__local__|__local__|themes|meriton-mpsw|views|components|promocode'] = {
                c: () => require('partner/themes/meriton-mpsw/views/components/promocode.component.tsx'),
                cn: '__local__-__local__-promocode'
            };
componentDictionary['__local__|__local__|themes|meriton-tas|views|components|addtocart'] = {
                c: () => require('partner/themes/meriton-tas/views/components/addtocart.component.tsx'),
                cn: '__local__-__local__-addtocart'
            };
componentDictionary['__local__|__local__|themes|meriton-tas|views|components|carticon'] = {
                c: () => require('partner/themes/meriton-tas/views/components/carticon.component.tsx'),
                cn: '__local__-__local__-carticon'
            };
componentDictionary['__local__|__local__|themes|meriton-tas|views|components|cartlineitem'] = {
                c: () => require('partner/themes/meriton-tas/views/components/cartlineitem.component.tsx'),
                cn: '__local__-__local__-cartlineitem'
            };
componentDictionary['__local__|__local__|themes|meriton-tas|views|components|price'] = {
                c: () => require('partner/themes/meriton-tas/views/components/price.component.tsx'),
                cn: '__local__-__local__-price'
            };
componentDictionary['__local__|__local__|themes|meriton-tas|views|components|product-v2'] = {
                c: () => require('partner/themes/meriton-tas/views/components/product-v2.component.tsx'),
                cn: '__local__-__local__-product-v2'
            };
componentDictionary['__local__|__local__|themes|meriton-tas|views|components|product'] = {
                c: () => require('partner/themes/meriton-tas/views/components/product.component.tsx'),
                cn: '__local__-__local__-product'
            };
componentDictionary['__local__|__local__|themes|meriton-tas|views|components|promocode'] = {
                c: () => require('partner/themes/meriton-tas/views/components/promocode.component.tsx'),
                cn: '__local__-__local__-promocode'
            };
componentDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|components|cartlineitem'] = {
                c: () => require('@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/components/cartlineitem.component.js'),
                cn: '@msdyn365-commerce-modules-fabrikam-design-kit-cartlineitem'
            };
componentDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|components|promocode'] = {
                c: () => require('@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/components/promocode.component.js'),
                cn: '@msdyn365-commerce-modules-fabrikam-design-kit-promocode'
            };
componentDictionary['@msdyn365-commerce-modules|order-management|modules|order-history-with-search-and-filters|components|order-history-with-search-and-filters-header'] = {
                c: () => require('@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history-with-search-and-filters/components/order-history-with-search-and-filters-header.component.js'),
                cn: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-header'
            };
componentDictionary['@msdyn365-commerce-modules|order-management|modules|order-history-with-search-and-filters|components|order-history-with-search-and-filters-order-list'] = {
                c: () => require('@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history-with-search-and-filters/components/order-history-with-search-and-filters-order-list.component.js'),
                cn: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-order-list'
            };
componentDictionary['@msdyn365-commerce-modules|order-management|modules|order-history-with-search-and-filters|components|order-history-with-search-and-filters-order-table'] = {
                c: () => require('@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history-with-search-and-filters/components/order-history-with-search-and-filters-order-table.component.js'),
                cn: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-order-table'
            };
componentDictionary['@msdyn365-commerce-modules|order-management|modules|order-history-with-search-and-filters|components|order-history-with-search-and-filters-organization-wide-selector'] = {
                c: () => require('@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history-with-search-and-filters/components/order-history-with-search-and-filters-organization-wide-selector.component.js'),
                cn: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-organization-wide-selector'
            };
componentDictionary['@msdyn365-commerce-modules|order-management|modules|order-history-with-search-and-filters|components|order-history-with-search-and-filters-view-mode-selector'] = {
                c: () => require('@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history-with-search-and-filters/components/order-history-with-search-and-filters-view-mode-selector.component.js'),
                cn: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-view-mode-selector'
            };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|carticon'] = {
                c: () => require('@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/carticon.component.js'),
                cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-carticon'
            };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|cartlineitem'] = {
                c: () => require('@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/cartlineitem.component.js'),
                cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-cartlineitem'
            };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|product-v2'] = {
                c: () => require('@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/product-v2.component.js'),
                cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-product-v2'
            };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|product'] = {
                c: () => require('@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/product.component.js'),
                cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-product'
            };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|promocode'] = {
                c: () => require('@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/promocode.component.js'),
                cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-promocode'
            };